import React, { useEffect, useState } from "react";
import AccessSignupRequestsItem from "../Components/AccessSignupRequestsItem/AccessSignupRequestsItem";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function AccessSignupRequests() {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    const fetchRequests = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}signup-requests/`,
          {
            credentials: "include",
          }
        );
        const data = await response.json();
        if (!response.ok) {
          setError(data.message || t("error_occurred"));
        }
        setRequests(data.requests);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchRequests();
  }, []);

  const handleAccept = async (requestId) => {
    setError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}signup-requests/${requestId}/accept`,
        {
          method: "PATCH",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || t("error_occurred"));
      }
      setRequests((prevRequests) =>
        prevRequests.filter((req) => req._id !== requestId)
      );
    } catch (err) {
      setError(err.message);
    }
  };

  const handleReject = async (requestId) => {
    setError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}signup-requests/${requestId}/reject`,
        {
          method: "PATCH",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || t("error_occurred"));
      }
      setRequests((prevRequests) =>
        prevRequests.filter((req) => req._id !== requestId)
      );
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      {error && <p className="text-danger">{error}</p>}
      {requests.length === 0 ? (
        <p className="text-center">{t("no_signup_requests")}</p>
      ) : (
        requests.map((request) => (
          <AccessSignupRequestsItem
            key={request._id}
            request={request}
            handleAccept={handleAccept}
            handleReject={handleReject}
          />
        ))
      )}
    </div>
  );
}

export default AccessSignupRequests;
